import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { QueryProvider } from './lib/api/query-client'
import { ViewProvider } from './contexts/ViewContext'
import { CustomToaster } from './lib/toast'
import AuthGuard from './components/auth/AuthGuard'
import Login from './components/auth/Login'
import ConfirmLogin from './components/auth/ConfirmLogin'
import ForgotPassword from './components/auth/ForgotPassword'
import ResetPasswordCode from './components/auth/ResetPasswordCode'
import NewPassword from './components/auth/NewPassword'
import AdminLayout from './components/admin/AdminLayout'
import Welcome from './components/admin/Welcome'
import AdminDashboard from './components/admin/Dashboard'
import AdminUsers from './components/admin/Users'
import AdminSettings from './components/admin/Settings'
import Content from './components/admin/Content'
import PressReleaseWrapper from './components/admin/PressReleaseWrapper'
import StrategicPillarsWrapper from './components/admin/StrategicPillarsWrapper'
import ProgrammesWrapper from './components/admin/ProgrammesWrapper'
import PublicationsWrapper from './components/admin/PublicationsWrapper'
import PhotoGalleryWrapper from './components/admin/PhotoGalleryWrapper'
import Subscribers from './components/admin/Subscribers'
import AdminUsersPage from './components/admin/AdminUsers'

// Initialize API services
import './lib/api/services'

const AdminApp = () => {
  return (
    <QueryProvider>
      <CustomToaster />
      <Router>
        <Routes>
          {/* Authentication Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/confirm-login" element={<ConfirmLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/code" element={<ResetPasswordCode />} />
          <Route path="/reset-password/new-password" element={<NewPassword />} />

          {/* Welcome Page (No AdminLayout) */}
          <Route
            path="/admin"
            element={
              <AuthGuard requiredRole="admin_staff">
                <Welcome />
              </AuthGuard>
            }
          />

          {/* Protected Admin Routes */}
          <Route
            path="/admin/*"
            element={
              <AuthGuard requiredRole="admin_staff">
                <ViewProvider>
                  <AdminLayout>
                    <Routes>
                      <Route path="/dashboard" element={<AdminDashboard />} />
                      <Route path="/users" element={<AdminUsers />} />
                      <Route path="/content" element={<Content />} />
                      <Route path="/settings" element={<AdminSettings />} />
                      <Route path="/press-release" element={<PressReleaseWrapper />} />
                      <Route path="/strategic-pillars" element={<StrategicPillarsWrapper />} />
                      <Route path="/programmes" element={<ProgrammesWrapper />} />
                      <Route path="/publications" element={<PublicationsWrapper />} />
                      <Route path="/photo-gallery" element={<PhotoGalleryWrapper />} />
                      <Route path="/subscribers" element={<Subscribers />} />
                      <Route path="/admin-users" element={<AdminUsersPage />} />
                    </Routes>
                  </AdminLayout>
                </ViewProvider>
              </AuthGuard>
            }
          />

          {/* Catch-all route - redirect unknown routes to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </QueryProvider>
  )
}

export default AdminApp